try {
    window.$ = window.jQuery = require("jquery");
} catch (e) {}

window.axios = require("axios");

let csrfPromise = null;

async function getCsrfToken() {
    if (!csrfPromise) {
        csrfPromise = window.getCSRF().then((token) => {
            document.querySelector('meta[name="csrf-token"]').content = token;
            return token;
        });
    }

    return csrfPromise;
}

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;

window.axios.interceptors.request.use(async (config) => {
    const token = await getCsrfToken();

    config.headers["X-CSRF-TOKEN"] = token;

    return config;
});
